import React from "react";
import Grid from "@material-ui/core/Grid";
import { createStyles, Theme, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import { green } from "@material-ui/core/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    successBackground: {
      backgroundColor: green[700],
      color: theme.palette.getContrastText(green[700]),
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      padding: "0.5% 2%",
    },
    snackbar: {
      width: "40%",
    },
  })
);

interface IProps {
  successMessage: string | null;
  clearSuccessMessage: Function;
}

const SuccessAlert: React.FC<IProps> = ({ successMessage, clearSuccessMessage }: IProps) => {
  const classes = useStyles();
  const SlideComponent = (props: TransitionProps) => <Slide {...props} direction="left" />;

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      TransitionComponent={SlideComponent}
      className={classes.snackbar}
      open={Boolean(successMessage)}
      onClose={() => Boolean(successMessage) && clearSuccessMessage()}
      autoHideDuration={5000}
    >
      <Grid container>
        <Grid item xs={12}>
          <Paper className={classes.successBackground}>
            <Typography variant={"button"}>{successMessage}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Snackbar>
  );
};

export default SuccessAlert;
